// extracted by mini-css-extract-plugin
module.exports = {"info":"_7ca8149e","photo":"_2ee87d1c","title":"_dfb41770","description":"_c3677996","button":"_427c4286"};